export default {"src":"/_next/static/media/workato-logo.d627a872.svg","height":44,"width":288,"blurWidth":0,"blurHeight":0};